import React from 'react'

interface CardProps {
    children: React.ReactNode
    title?: string
    subtitle?: string
    className?: string
    headerClassName?: string
    bodyClassName?: string
    action?: React.ReactNode
}

const Card: React.FC<CardProps> = ({
    children,
    title,
    subtitle,
    className = '',
    headerClassName = '',
    bodyClassName = '',
    action
}) => {
    return (
        <div className={`bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden ${className}`}>
            {(title || action) && (
                <div className={`px-6 py-4 border-b border-gray-200 flex items-center justify-between ${headerClassName}`}>
                    <div>
                        {title && <h3 className="text-lg font-semibold text-gray-900">{title}</h3>}
                        {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
                    </div>
                    {action && <div>{action}</div>}
                </div>
            )}
            <div className={`p-6 ${bodyClassName}`}>{children}</div>
        </div>
    )
}

export default Card